// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import type { ClaritySearchFilterType } from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as ClarityContent from '@components/popups/content/Clarity';

const steps = ['F', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1'];
const baseSliderOpts = {
  range: {
    min: 0,
    max: steps.length
  },
  step: 1,
  margin: 1,
  connect: [false, true, false]
};

function getStartValues(stateValues = []) {
  if (stateValues.length === 0) return [0, steps.length];

  let min = steps.length; // start at the max possible
  let max = 0; // start at the min possible

  stateValues.forEach(value => {
    const index = steps.indexOf(value);
    if (min > index) min = index;
    if (max < index) max = index;
  });

  return [min, max + 1];
}

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: ClaritySearchFilterType | void
};

const Popup = () => <QuestionMarkPopup initialContent={ClarityContent} />;

export default class ClaritySlider extends React.Component<PropsType> {
  render() {
    const sliderOpts = {
      ...baseSliderOpts,
      start: getStartValues(this.props.value)
    };

    return (
      <GenericSlider
        title={'Clarity'}
        sliderMarginTop={'0'}
        titleMarginBottom={'2px'}
        sliderOpts={sliderOpts}
        onSliderUpdate={steps =>
          this.props.onSliderUpdate('UPDATE_CLARITY', steps)
        }
        steps={steps}
        Popup={Popup}
      />
    );
  }
}
